import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-12 md:col-6" }
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "font-medium mb-1" }

import Image from 'primevue/image';

const __default__ = {
    inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ViewImage',
  props: {
    images: {},
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_unref(Image), _mergeProps({
            src: image.url,
            alt: _ctx.title
          }, _ctx.$attrs), null, 16, ["src", "alt"])
        ]))
      }), 128))
    ])
  ]))
}
}

})